import { useState, useEffect, useCallback } from 'react';

export default function Intro({ onComplete }: { onComplete: () => void }) {
  const [phase, setPhase] = useState<'in' | 'hold' | 'out'>('in');

  const finish = useCallback(() => {
    setPhase('out');
    setTimeout(() => {
      onComplete();
    }, 700);
  }, [onComplete]);

  useEffect(() => {
    document.body.style.overflow = 'hidden';

    const t1 = setTimeout(() => setPhase('hold'), 1000);
    const t2 = setTimeout(() => finish(), 3200);

    return () => {
      document.body.style.overflow = '';
      clearTimeout(t1);
      clearTimeout(t2);
    };
  }, [finish]);

  return (
    <div
      style={{ backgroundColor: '#781725' }}
      className={`fixed inset-0 z-[100] flex flex-col items-center justify-center cursor-pointer transition-all duration-700 ease-out ${
        phase === 'out'
          ? 'opacity-0 -translate-y-5 pointer-events-none'
          : 'opacity-100 translate-y-0'
      }`}
      onClick={finish}
    >
      <div
        className={`text-center transition-all duration-[900ms] ease-out ${
          phase === 'in'
            ? 'opacity-0 translate-y-6 scale-95'
            : 'opacity-100 translate-y-0 scale-100'
        }`}
      >
        <p className="text-white text-lg md:text-3xl lg:text-4xl font-light tracking-[0.12em] mb-3">
          사건사고 다
        </p>
        <h1 className="font-heading text-white text-4xl md:text-6xl lg:text-7xl font-extrabold tracking-tight leading-[1.2]">
          당신의 마음까지 다
        </h1>
      </div>

      <div className="absolute bottom-12 flex flex-col items-center gap-3">
        <span className="text-white/40 text-[10px] tracking-[0.35em]">
          CLICK TO ENTER
        </span>
        <div className="w-px h-8 bg-white/30 animate-pulse" />
      </div>
    </div>
  );
}